var _path, _path2, _path3, _path4, _path5, _circle, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSenderBlocked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9923 43.6622C43.4869 43.6622 43.888 44.0874 43.888 44.6119V71.6785C43.888 72.203 43.4869 72.6283 42.9923 72.6283H0.895761C0.401094 72.6283 0 72.203 0 71.6785V44.6119C0 44.0874 0.401094 43.6622 0.895761 43.6622H42.9923ZM3.77163 46.5588C2.94702 46.5588 2.61185 47.6428 3.2866 48.1273L21.0547 60.8848C21.3406 61.0901 21.7211 61.0946 22.0112 60.8954L40.5871 48.1379C41.279 47.6627 40.95 46.5588 40.1164 46.5588H3.77163Z",
    fill: "#DAE0E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.15 69.0392C123.545 69.0392 123.865 69.3788 123.865 69.7977V91.4121C123.865 91.8309 123.545 92.1705 123.15 92.1705H89.533C89.138 92.1705 88.8177 91.8309 88.8177 91.4121V69.7977C88.8177 69.3788 89.138 69.0392 89.533 69.0392H123.15ZM91.8296 71.3524C91.1711 71.3524 90.9034 72.218 91.4423 72.6049L105.631 82.7926C105.86 82.9565 106.163 82.9601 106.395 82.8011L121.229 72.6134C121.782 72.2339 121.519 71.3524 120.853 71.3524H91.8296Z",
    fill: "#DAE0E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.335 22.5156C116.773 22.5156 117.128 22.8924 117.128 23.3571V47.3375C117.128 47.8022 116.773 48.1789 116.335 48.1789H79.0381C78.5998 48.1789 78.2444 47.8022 78.2444 47.3375V23.3571C78.2444 22.8924 78.5998 22.5156 79.0381 22.5156H116.335ZM81.586 25.082C80.8554 25.082 80.5585 26.0424 81.1563 26.4716L96.8984 37.7745C97.1517 37.9564 97.4889 37.9604 97.7458 37.7839L114.204 26.481C114.817 26.06 114.525 25.082 113.787 25.082H81.586Z",
    fill: "#DAE0E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0193 32.2925C76.0193 42.9474 67.3818 51.5849 56.7268 51.5849C46.0719 51.5849 37.4344 42.9474 37.4344 32.2925C37.4344 21.6375 46.0719 13 56.7268 13C67.3818 13 76.0193 21.6375 76.0193 32.2925Z",
    fill: "#004099"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3887 53.9995C70.5209 53.9995 82.1499 60.4283 89.3066 70.3081C87.2847 69.6668 85.1316 69.3198 82.8975 69.3198C71.2011 69.3198 61.7188 78.8022 61.7188 90.4985C61.7188 93.0383 62.1666 95.4734 62.9863 97.7299H18V93.3891C18 71.6354 35.6349 53.9995 57.3887 53.9995Z",
    fill: "#004099"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.8961,
    cy: 90.4977,
    r: 21.1781,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0199 79.9697L93.0595 100.893M97.5579 90.432C97.5579 98.6795 90.8349 105.365 82.5417 105.365C74.2486 105.365 67.5256 98.6795 67.5256 90.432C67.5256 82.1845 74.2486 75.4985 82.5417 75.4985C90.8349 75.4985 97.5579 82.1845 97.5579 90.432Z",
    stroke: "#AD1F2A",
    strokeWidth: 2.64124,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSenderBlocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/senderBlocked.8ca69f32037864714fc0ccf7267a8b21.svg";